import { PercentSlider, SelectField, SideTabs, TextField } from "@/ui/wx";

const OT_LABEL: Record<string, string> = {
  market: "بازار",
  limit: "حد",
  stop: "استاپ",
  stop_loss: "حدضرر",
  target_buy: "هدف‌خرید",
  target_sell: "هدف‌فروش",
  stop_target: "استاپ‌هدف",
};

export function TradeForm({
  side,
  onSide,
  orderTypes,
  orderType,
  onOrderType,
  amount,
  onAmount,
  amountSuffix,
  quoteSuffix = "USDT",
  limit,
  onLimit,
  trigger,
  onTrigger,
  pct,
  onPct,
  busy,
  disabled,
  onSubmit,
  irrBalance,
  availableLabel,
  availableText,
}: {
  side: "buy" | "sell";
  onSide: (s: "buy" | "sell") => void;
  orderTypes: string[];
  orderType: string;
  onOrderType: (t: string) => void;
  amount: string;
  onAmount: (v: string) => void;
  amountSuffix: string;
  quoteSuffix?: string;
  limit: string;
  onLimit: (v: string) => void;
  trigger: string;
  onTrigger: (v: string) => void;
  pct: number;
  onPct: (v: number) => void;
  busy: boolean;
  disabled?: boolean;
  onSubmit: () => void;
  irrBalance?: string;
  availableLabel?: string;
  availableText?: string;
}) {
  const needLimit = orderType === "limit" || orderType.startsWith("target");
  const needTrigger = orderType !== "market" && orderType !== "limit";

  return (
    <div className="wx-trade-form" dir="rtl">
      <SideTabs side={side} onChange={onSide} />
      {availableText != null ? (
        <div className="row-between" style={{ marginBottom: 8 }}>
          <span className="muted">{availableLabel || "موجودی"}</span>
          <b className="ltr">{availableText}</b>
        </div>
      ) : irrBalance != null ? (
        <div className="row-between" style={{ marginBottom: 8 }}>
          <span className="muted">موجودی ریال</span>
          <b className="ltr">{irrBalance}</b>
        </div>
      ) : null}
      <SelectField
        label="نوع"
        value={orderType}
        onChange={onOrderType}
        options={orderTypes.map((t) => ({ value: t, label: OT_LABEL[t] || t }))}
      />
      <TextField label="مقدار" value={amount} onChange={onAmount} suffix={amountSuffix} />
      {needLimit ? (
        <TextField label="قیمت" value={limit} onChange={onLimit} suffix={quoteSuffix} />
      ) : null}
      {needTrigger ? (
        <TextField label="تریگر" value={trigger} onChange={onTrigger} suffix={quoteSuffix} />
      ) : null}
      <PercentSlider value={pct} onChange={onPct} tone={side} />
      <button
        type="button"
        className={`wx-submit ${side}`}
        disabled={busy || disabled}
        onClick={onSubmit}
      >
        {busy ? "…" : side === "buy" ? "خرید" : "فروش"}
      </button>
    </div>
  );
}
